export const RESET_ERRORS = 'RESET_ERRORS';

export const resetErrors = () => async (dispatch) => {
  await dispatch({
    type: RESET_ERRORS,
  });
};
